import { useAuthStore } from '~/stores/use-auth-store';

export default defineNuxtPlugin({
  name: 'auth',
  dependsOn: ['msw'],
  async setup() {
    const authStore = useAuthStore();
    await authStore.fetchUser();
  },
});
